module.exports = {
  printList:
    'inner_trans_batch_detail_right_print, inner_trans_in_batch_detail_right_print, trans_batch_detail_right_print, trans_in_batch_detail_right_print,pack_list_print', // listPage printList
};
